import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Draggable from 'react-draggable';
import styles from './ModalStyles';

import closeX from '../../../images/clear-field-icon_white.png';

export default class ModalStateless extends Component {
  onOverlayClicked() {
    if (this.props.onOverlayClicked) {
      this.props.onOverlayClicked();
    }
  }

  onCloseClicked() {
    if (this.props.onCloseClicked) {
      this.props.onCloseClicked();
    }
  }

  assign = (target, ...args) => {
    if (target === null) {
      throw new TypeError('Cannot convert undefined or null to object');
    }

    const newTarget = target;
    for (let index = 0; index < args.length; index += 1) {
      const source = args[index];
      if (source !== null) {
        for (const key in source) {
          if (Object.prototype.hasOwnProperty.call(source, key)) {
            newTarget[key] = source[key];
          }
        }
      }
    }
    return newTarget;
  }

  render() {
    const mergeStyles = key => this.assign({}, styles[key], this.props[key]);
    const { isVisible, isDragDisabled, normalize } = this.props;
    const dialogStyles = mergeStyles('dialogStyles');
    const headerStyles = mergeStyles('headerStyles');
    const bodyStyles = mergeStyles('bodyStyles');
    // const footerStyles = mergeStyles('footerStyles');
    const overlayStyles = mergeStyles('overlayStyles');
    const closeButtonStyle = mergeStyles('closeButtonStyle');
    const titleStyle = mergeStyles('titleStyle');
    overlayStyles.display = dialogStyles.display = 'block';

    let overlay;
    if (this.props.showOverlay) {
      overlay = (
        <div
          className="modal-overlay"
          onClick={() => this.onOverlayClicked()}
          style={overlayStyles}
        />
      );
    }

    return isVisible ? (
      <section className="modal-wrapper">
        {overlay}
        <Draggable handle=".modal-header" disabled={isDragDisabled}>
          <div className="modal-dialog" style={dialogStyles}>
            <div className="modal-header" style={headerStyles}>
              {(!this.props.hideCloseButton) && <a
                role="button"
                className="modal-close-button"
                onClick={() => this.onCloseClicked()}
                style={closeButtonStyle}
              >
                <img src={closeX} alt="close icon" />
              </a>
              }
              <span style={titleStyle}>{this.props.title}</span>
            </div>
            <div className={normalize ? 'modal-body-normal' : 'modal-body'} style={bodyStyles}>
              {this.props.children}
            </div>
          </div>
        </Draggable>
      </section>
    ) : (
      <div />
    );
  }
}

ModalStateless.displayName = 'ModalStateless';

ModalStateless.sharedPropTypes = {
  closeButtonStyle: PropTypes.object,
  dialogStyles: PropTypes.object,
  headerStyles: PropTypes.object,
  footerStyles: PropTypes.object,
  bodyStyles: PropTypes.object,
  onCloseClicked: PropTypes.func,
  onOverlayClicked: PropTypes.func,
  overlayStyles: PropTypes.object,
  showOverlay: PropTypes.bool,
  title: PropTypes.string,
  titleStyle: PropTypes.object,
  hideCloseButton: PropTypes.bool,
};

ModalStateless.propTypes = {
  ...ModalStateless.sharedPropTypes,
  isVisible: PropTypes.bool,
};

ModalStateless.defaultProps = {
  title: '',
  showOverlay: true,
  overlayStyles: styles.overlayStyles,
  dialogStyles: styles.dialogStyles,
  headerStyles: styles.headerStyles,
  footerStyles: styles.footerStyles,
  bodyStyles: styles.bodyStyles,
  closeButtonStyle: styles.closeButtonStyle,
  hideCloseButton: false,
};
